import axios from "axios";
import {
  clearStoredMessagingFid,
  getStoredMessagingFid,
  observeMessagingRegistration
} from "./firebase.utils.js";

const registerInstallation = (fid, bodyshopid) => axios.post("/notifications/register", { fid, bodyshopid });

const unregisterInstallation = (fid) => axios.post("/notifications/unregister", { fid });

export const startMessagingInstallationSync = (bodyshopid) =>
  observeMessagingRegistration({
    onRegistration: (fid) => registerInstallation(fid, bodyshopid),
    onUnregistration: (fid) => unregisterInstallation(fid)
  });

export const unregisterCurrentMessagingInstallation = async () => {
  const fid = getStoredMessagingFid();
  if (!fid) return null;

  const response = await unregisterInstallation(fid);
  clearStoredMessagingFid(fid);
  return response.data;
};
